import { type FC } from 'react';

import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    className?: string;
    dimensionValues: string;
};

export const ProductDimensions: FC<Props> = ({ className, dimensionValues }) => {
    return (
        <span
            className={classnames(dibsCss.truncate, className)}
            data-tn="product-tile-measurements"
        >
            {dimensionValues}
        </span>
    );
};
